<template>
  <generic-modal
    :title="$t('ordering link')"
    ref="generic_modal"
    size="fullscreen"
  >
    <form>
      <div class="columns">
        <div class="column">
          <div class="field">
            <label class="label">{{ $t("establishment") }}</label>
            <div class="control">
              <input
                type="text"
                class="input"
                v-model="meta.establishment"
                :placeholder="$t('establishment')"
              />
            </div>
          </div>
        </div>
        <div class="column">
          <div class="field">
            <generic-dropdown
              :title="$t('administrator roles')"
              :placeholder="$t('select')"
              url="/access/role/catalog"
              name_field="name"
              value_field="role_id"
              @change="set_roles"
              ref="roles_dropdown"
            />
          </div>
        </div>
        <div class="column">
          <div class="field">
            <input
              class="is-checkradio"
              type="checkbox"
              id="chk_is_enabled"
              v-model="meta.is_enabled"
            />
            <label for="chk_is_enabled">{{ $t("is enabled") }}</label>
          </div>
        </div>
      </div>
      <div class="columns">
        <div class="column">
          <div class="field">
            <label class="label">{{ $t("bank") }}</label>
            <div class="control">
              <div class="select">
                <select v-model="meta.bank">
                  <option>BI</option>
                  <option>G&T Continental</option>
                  <option>BAM</option>
                  <option>BAC</option>
                </select>
              </div>
            </div>
          </div>
        </div>
        <div class="column">
          <div class="field">
            <label class="label">{{ $t("account type") }}</label>
            <div class="control">
              <div class="select">
                <select v-model="meta.bank_account_type">
                  <option value="savings">{{ $t("savings") }}</option>
                  <option value="monetary">{{ $t("monetary") }}</option>
                </select>
              </div>
            </div>
          </div>
        </div>
        <div class="column">
          <div class="field">
            <label class="label">{{ $t("account name") }}</label>
            <div class="control">
              <input
                type="text"
                class="input"
                v-model="meta.bank_account_name"
              />
            </div>
          </div>
        </div>
        <div class="column">
          <div class="field">
            <label class="label">{{ $t("account number") }}</label>
            <div class="control">
              <input
                type="text"
                class="input"
                v-model="meta.bank_account_number"
              />
            </div>
          </div>
        </div>
      </div>
      <div class="columns">
        <div class="column">
          <div class="field">
            <label class="label">{{ $t("url name") }}</label>
            <div class="control">
              <input
                type="text"
                class="input"
                v-model="meta.url_name"
                placeholder="margarita-tejada"
              />
            </div>
          </div>
        </div>
        <div class="column">
          <div class="field">
            <label class="label">{{ $t("prefix for order number") }}</label>
            <div class="control">
              <input
                type="text"
                class="input"
                v-model="meta.order_number_prefix"
                placeholder="fmt"
              />
            </div>
          </div>
        </div>
        <div class="column">
          <div class="field">
            <label class="label">{{ $t("available payment methods") }}</label>
            <div class="control">
              <div class="select is-multiple">
                <select multiple v-model="meta.available_payment_methods">
                  <option value="deposit">{{ $t("deposit") }}</option>
                  <option value="transference">{{ $t("transference") }}</option>
                  <option value="cash">{{ $t("cash") }}</option>
                  <option value="administrative_payment">
                    {{ $t("administrative payment") }}
                  </option>
                </select>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="box mt-0">
        <div class="columns">
          <div class="column is-5">
            <h1 class="title is-4">{{ $t("product list") }}</h1>
          </div>
          <div class="column is-7">
            <div class="buttons is-pulled-right">
              <div class="button is-secondary is-rounded" @click="create">
                <span class="icon"><i class="fa fa-plus"></i></span>
                <span>{{ $t("add") }}</span>
              </div>
              <!-- <button
              class="button is-primary is-rounded"
              @click="refresh"
              :disabled="is_loading"
              v-bind:class="{ 'is-loading': is_loading }"
              :data-tooltip="$t('refresh')"
            >
              <span class="icon">
                <i class="fa fa-refresh"></i>
              </span>
              <span>{{ $t("refresh") }}</span>
            </button> -->
            </div>
          </div>
        </div>
        <div class="container" ref="tc">
          <table class="table is-fullwidth is-striped">
            <thead>
              <tr>
                <th>{{ $t("product") }}</th>
                <th>{{ $t("price") }}</th>
                <th>{{ $t("available sizes") }}</th>
                <th>{{ $t("actions") }}</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(product, pidx) in meta.products" :key="pidx">
                <td>
                  {{ product.name }}
                  <generic-dropdown
                    :title="$t('product')"
                    :placeholder="$t('select')"
                    url="/product/catalog"
                    name_field="name"
                    value_field="product_id"
                    @selected="set_product(pidx, $event)"
                    ref="product_dropdown"
                    :is_multiple="false"
                    :show_title="false"
                  />
                </td>
                <td>
                  <input type="text" class="input" v-model="product.price" />
                </td>
                <td>
                  {{
                    Object.keys(product.available_sizes)
                      .filter((size) => product.available_sizes[size])
                      .join(", ")
                      .toUpperCase()
                  }}
                </td>
                <td>
                  <div
                    class="button is-danger"
                    @click="meta.products.splice(pidx, 1)"
                  >
                    <span class="icon"><i class="fa fa-trash"></i></span>
                  </div>
                  <div class="dropdown" ref="size_dropdown">
                    <div class="dropdown-trigger">
                      <div
                        class="button"
                        @click="show_product_sizes(product, pidx)"
                        aria-haspopup="true"
                        aria-controls="dropdown-menu3"
                      >
                        <span>{{ $t("select sizes") }}</span>
                        <span class="icon is-small">
                          <i class="fa fa-angle-down" aria-hidden="true"></i>
                        </span>
                      </div>
                    </div>
                    <div class="dropdown-menu" role="menu">
                      <div class="dropdown-content">
                        <a
                          v-for="(size, sidx) in product.available_sizes"
                          :key="sidx"
                          href="#"
                          class="dropdown-item"
                        >
                          <input
                            class="is-checkradio"
                            type="checkbox"
                            :id="`chk_is_enabled_${pidx}_${sidx}`"
                            v-model="meta.products[pidx].available_sizes[sidx]"
                          />
                          <label :for="`chk_is_enabled_${pidx}_${sidx}`">{{
                            sidx.toUpperCase()
                          }}</label>
                        </a>
                      </div>
                    </div>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
          <!-- <div class="grid is-col-min-10">
            <div
              class="cell"
              v-for="(product, pidx) in meta.products"
              :key="pidx"
            >
              <div class="card">
                <header class="card-header">
                  <p class="card-header-title">
                    {{ product.name }}
                  </p>
                  <div
                    class="card-header-icon"
                    aria-label="more options"
                    @click="meta.products.splice(pidx, 1)"
                  >
                    <span class="icon has-text-danger">
                      <i class="fa fa-trash" aria-hidden="true"></i>
                    </span>
                  </div>
                </header>
                <div class="card-content">
                  <div class="content">
                    <div class="columns">
                      <div class="column">
                        <div class="field">
                          <label class="label">{{
                            $t("available sizes")
                          }}</label>
                          <div class="control"></div>
                        </div>
                      </div>
                      <div class="column">
                        <div class="field">
                          <label class="label">{{ $t("price") }}</label>
                          <div class="control">
                            <input
                              type="text"
                              class="input"
                              v-model="product.price"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div> -->
          <!-- <div class="columns">
            <div class="column is-two-fifths">
              <h1 class="title is-6">{{ $t("product") }}</h1>
            </div>
            <div class="column">
              <h1 class="title is-6">{{ $t("available sizes") }}</h1>
            </div>
          </div>
          <div
            class="columns"
            v-for="(product, pidx) in meta.products"
            :key="pidx"
          >
            <div class="column is-two-fifths">
              <generic-dropdown
                :title="$t('product')"
                :placeholder="$t('select')"
                url="/product/catalog"
                name_field="name"
                value_field="product_id"
                @selected="set_product(pidx, $event)"
                ref="product_dropdown"
                :is_multiple="false"
                :show_title="false"
              />
              <div class="columns mt-2">
                <div class="column">
                  <span
                    class="has-text-warning"
                    v-if="
                      !meta.products[pidx].product && meta.products[pidx].name
                    "
                    >{{ meta.products[pidx].name }}</span
                  >
                  <div class="tag is-medium" v-if="meta.products[pidx].product">
                    <a
                      class="button"
                      :data-tooltip="$t('delete')"
                      @click="meta.products.splice(pidx, 1)"
                    >
                      <span class="icon has-text-danger">
                        <i class="fa fa-trash"></i>
                      </span>
                    </a>
                    <span>{{ meta.products[pidx].name }}</span>
                  </div>
                </div>
                <div class="column">
                  <input
                    type="text"
                    class="input"
                    v-model="meta.products[pidx].price"
                  />
                </div>
              </div>
            </div>
            <div class="column">
              <div class="grid is-col-min-3">
                <div
                  class="cell"
                  v-for="(size, sidx) in product.available_sizes"
                >
                  <div class="field">
                    <div class="control">
                      <input
                        class="is-checkradio"
                        type="checkbox"
                        :id="`chk_is_enabled_${pidx}_${sidx}`"
                        v-model="meta.products[pidx].available_sizes[sidx]"
                      />
                      <label :for="`chk_is_enabled_${pidx}_${sidx}`">{{
                        sidx.toUpperCase()
                      }}</label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div> -->
        </div>
      </div>
      <div class="box mt-0">
        <div class="columns">
          <div class="column is-7">
            <h1 class="title is-4">{{ $t("classroom/program list") }}</h1>
          </div>
          <div class="column is-5">
            <div class="buttons is-pulled-right">
              <div
                class="button is-secondary is-rounded"
                @click="create_classroom"
              >
                <span class="icon"><i class="fa fa-plus"></i></span>
                <span>{{ $t("add") }}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="table-container" ref="tc">
          <div class="columns">
            <div class="column">
              <h1 class="title is-6">{{ $t("classroom") }}</h1>
            </div>
            <div class="column is-one-fifth">
              <h1 class="title is-6">{{ $t("options") }}</h1>
            </div>
          </div>
          <div
            class="columns"
            v-for="(classroom, pidx) in meta.classrooms"
            :key="pidx"
          >
            <div class="column is-two-fifths">
              <div class="field">
                <div class="control">
                  <input
                    type="text"
                    class="input"
                    v-model="meta.classrooms[pidx].name"
                    :placeholder="$t('classroom')"
                  />
                </div>
              </div>
            </div>
            <div class="column is-one-fifth">
              <p class="buttons">
                <a
                  class="button"
                  :data-tooltip="$t('delete')"
                  @click="meta.classrooms.splice(pidx, 1)"
                >
                  <span class="icon has-text-danger">
                    <i class="fa fa-trash"></i>
                  </span>
                </a>
              </p>
            </div>
          </div>
        </div>
      </div>
    </form>
    <div class="notification is-danger mt-5" v-if="error">
      <p v-html="error"></p>
    </div>
    <template v-slot:footer>
      <button
        class="button is-primary is-rounded"
        @click="save"
        :disabled="is_form_invalid"
      >
        <span class="icon">
          <i class="fa fa-save"></i>
        </span>
        <span>{{ $t("save") }}</span>
      </button>
      <button class="button is-rounded" @click="close_modal">
        <span class="icon">
          <i class="fa fa-close"></i>
        </span>
        <span>{{ $t("cancel") }}</span>
      </button>
    </template>
  </generic-modal>
</template>
<script>
import {
  put,
  post,
  generate_error_message_text,
  format_currency,
} from "@/utils";
import { v4 } from "uuid";
import GenericModal from "@/components/generic_modal/Index.vue";
import GenericDropdown from "@/components/generic_dropdown/Index.vue";

export default {
  name: "OrderingLinkModal",
  components: { GenericModal, GenericDropdown },
  props: {},
  data() {
    return {
      meta: {},
      error: "",
      provider_uuid: undefined,
    };
  },
  computed: {
    is_form_invalid() {
      let v = this;
      // return false;
      return !v.meta.establishment;
    },
  },
  methods: {
    format_currency,
    close_modal() {
      let v = this;
      v.set_initial_state();
      v.$refs.generic_modal.close_modal();
    },
    show_modal(ordering_link) {
      let v = this;
      v.set_initial_state();
      Object.keys(ordering_link).map((k) => {
        v.meta[k] = JSON.parse(JSON.stringify(ordering_link[k]));
        if (k == "admin_roles") {
          v.$refs.roles_dropdown.set_value(v.meta[k]);
        }
      });
      v.$refs.generic_modal.show_modal();
    },
    save() {
      let v = this;
      let ordering_link = { ...v.meta };
      v.$emit("success", ordering_link);
      v.$refs.generic_modal.close_modal();
    },
    set_initial_state() {
      let v = this;
      v.provider_uuid = undefined;
      v.meta = {
        name: "",
        available_payment_methods: [],
        products: [],
        classrooms: [],
      };
      v.error = "";
    },
    create() {
      let v = this;
      v.meta.products.push({
        uuid: v4(),
        name: v.$t("new product"),
        available_sizes: {
          2: true,
          4: true,
          6: true,
          8: true,
          10: true,
          12: true,
          14: true,
          16: true,
          s: true,
          m: true,
          l: true,
          xl: true,
          uniq: true,
          28: true,
          30: true,
          32: true,
          34: true,
          36: true,
          38: true,
          40: true,
        },
      });
    },
    set_roles(value) {
      let v = this;
      v.meta.admin_roles = value;
    },
    set_product(pidx, product) {
      let v = this;
      v.meta.products[pidx].product = product;
      v.meta.products[pidx].price = product.sale_price;
      v.meta.products[pidx].name = product.name;
    },
    create_classroom() {
      let v = this;
      v.meta.classrooms.push({
        uuid: v4(),
        name: v.$t("new classroom/program"),
      });
    },
    show_product_sizes(product, index) {
      let v = this;
      // console.log("product", product);
      let target = v.$refs.size_dropdown[index];
      target.classList.toggle("is-active");
    },
  },
  mounted() {},
  watch: {},
};
</script>
<style>
.available.size {
  padding: 30px 0 0 0 !important;
}
</style>
